export default __webpack_public_path__ + "images/XN.1666e81.png";